import { routerGetCall } from '../../axios';

export const getInvestRequestConfigUrl = `/cms/invest-requests-config`;

const getInvestRequestSetting = (state, params) => {
  const url = getInvestRequestConfigUrl;
  return routerGetCall(state, url, params);
};
export default { getInvestRequestSetting };

// https://c360-core.azure-api.net/cms/getUserLocation
// https://c360-core.azure-api.net/cms/locale
